// extracted by mini-css-extract-plugin
export default {"toggle":"hB3n1Z","focus":"hfCC2_","input":"g4BQnU","label":"EaTE6z","track":"fve_dT","knob":"tFjtot","icon":"YtCu80","iconTrue":"SDQhnQ","iconFalse":"IXCAQH"};